var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQueryFilled = function SvgQueryFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 2.708H3.333c-.575 0-1.041.467-1.041 1.042v10.417c0 .575.466 1.041 1.041 1.041h7.842l2.85 2.85a.921.921 0 0 0 1.017.2.935.935 0 0 0 .583-.866v-2.184h1.042c.575 0 1.041-.466 1.041-1.041V3.75c0-.575-.466-1.042-1.041-1.042Zm-6.55 9.167a.733.733 0 1 1 0-1.467c.4 0 .733.325.741.725 0 .409-.35.742-.741.742Zm1.225-3.017c-.442.259-.65.509-.65 1.025V10h-1.2v-.117c0-.983.25-1.283.716-1.575.359-.233.634-.458.634-.816 0-.35-.284-.592-.634-.584-.35 0-.658.242-.666.65H8.25c.017-1.191.9-1.733 1.967-1.733 1.183 0 2.033.567 2.033 1.6 0 .692-.367 1.108-.908 1.433Z",
    fill: "current"
  })));
};
export default SvgQueryFilled;